import angular from 'angular';

export default angular.module('shared').constant('authenticationConstants', {
    billing: {
        name: 'billing'
    },
    support: {
        name: 'customersupport'
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/authentication.constant.js